module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAABYlAAAWJQFJUiTwAAAA9klEQVR4nO2a2wqDMBAFl35p/v/FT2gpdKFEDbE1tz0zkBcVPLOi5mYAAAAAAACVJDPbPi1NULTued43en61kUVIWZZtd0UD8gKMKkIu360ARzfuXYThGUYGmOEBDAsyjfyIQNPJ9ww2rbzTMuD08k6LoMvIO3cGXk7euSP4svLOPwLLyzu/iISRd64IhZN3asTCyjslwdK5UJyJHrVw8k5NEcLKO6UidJd/7I5AU0pPP/wrIP0RPJOX+A1Kd4Sku8LSgyHp4bD0hIj0lJj0pKj0tLj0woj00pj04qj08rj8Bgn5LTLym6SS+jY5AAAAAABYHDN7Aaogn2SQvIGCAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SP/@2x/ic_menu_close@2x.png
// module id = 709
// module chunks = 0